export default class Accordion {
  constructor(component) {
    this.dom = {
      $component: component,
      $toggles: component.querySelectorAll('.js-toggle'),
      $contents: component.querySelectorAll('.js-content'),
      $header: document.querySelector('.js-header'),
    }

    this.state = {
      headerHeight: 84,
    }

    this.mount()
    this.bindToWindow()
  }

  viewBtnClick($toggle) {
    const { dom } = this
    const isOpen = $toggle.getAttribute('aria-expanded') == 'true'
    const $content = $toggle.nextElementSibling

    if (isOpen) {
      $toggle.setAttribute('aria-expanded', 'false')
      $content.setAttribute('aria-hidden', 'true')
      $content.style.maxHeight = 0
    } else {
      $toggle.setAttribute('aria-expanded', 'true')
      $content.setAttribute('aria-hidden', 'false')
      $content.style.maxHeight = `${$content.scrollHeight}px`
    }
  }

  mount() {
    const { dom: { $toggles } } = this

    window.addEventListener('DOMContentLoaded', this.openOnLoad.bind(this))

    $toggles.forEach(($toggle) => {
      $toggle.addEventListener('click', () => { this.viewBtnClick($toggle) })
    })
  }

  openOnLoad() {
    const { dom } = this

    const { hash } = window.location
    if (!hash) return
    const locale = dom.$component.querySelector(`${hash}-toggle`)
    if (locale) {
      locale.click()
      setTimeout(() => {
        const { top } = locale.getBoundingClientRect()
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop
        window.scrollTo(0, (top + scrollTop) - dom.$header.scrollHeight)
      }, 500)
    }
  }

  unmount() {
  }

  bindToWindow() {
    window.theme = window.theme || {}
    window.theme.Accordion = this
  }
}
